import React from 'react';
import type { TestPhase } from '../types/diagnostics';

interface Props {
  phase: TestPhase;
  progress: number;
}

const phaseLabels: Record<TestPhase, string> = {
  idle: 'Ready',
  connecting: 'Connecting…',
  info: 'Getting network info…',
  latency: 'Measuring latency…',
  download: 'Testing download speed…',
  upload: 'Testing upload speed…',
  analysis: 'Analyzing results…',
  complete: 'Complete',
  error: 'Error',
};

export const ProgressBar: React.FC<Props> = ({ phase, progress }) => {
  if (phase === 'idle' || phase === 'complete') return null;

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-1">
        <span className="text-sm text-slate-300">{phaseLabels[phase]}</span>
        <span className="text-xs text-slate-500">{Math.round(progress)}%</span>
      </div>
      <div className="w-full bg-dark-800 rounded-full h-2 overflow-hidden">
        <div
          className="h-full rounded-full bg-gradient-to-r from-blue-500 via-cyan-400 to-emerald-400 transition-all duration-300 ease-out"
          style={{ width: `${Math.min(100, progress)}%` }}
        />
      </div>
    </div>
  );
};
